import { AuthKey, LocalStorageKey } from "../constants/keys";
import Unauth from "../components/middleware/unauth";
import { useLoadingContext } from "react-router-loading";
import useAccountContext from "../contexts/AccountContext";
import Navbar from "../components/Navbar/Navbar";
import { isJwtExpired } from "../../core/auth";

function withAuth(authType: AuthKey) {
  return <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    return function WithAuthComponent(props: P) {
      const loadingContext = useLoadingContext();
      const { accountData } = useAccountContext();

      const auth = localStorage.getItem(LocalStorageKey.Auth);

      if (!auth) {
        localStorage.clear();
        loadingContext.done();
        console.log("No token found");
        return <Unauth />;
      }

      if (isJwtExpired(auth!)) {
        localStorage.clear();
        loadingContext.done();
        console.log("Token expired");
        return <Unauth />;
      }

      // for dev
      // if (authType === AuthKey.UserAuth) {
      //   return (
      //     <>
      //       <Navbar />
      //       <WrappedComponent {...props} />
      //     </>
      //   );
      // }

      // for prod
      if (
        (authType === AuthKey.AdminAuth && accountData?.isAdmin) ||
        (authType === "Both" && accountData)
      ) {
        return (
          <>
            <Navbar />
            <WrappedComponent {...props} />
          </>
        );
      } else {
        loadingContext.done();
        console.log("Unauthorized access");
        localStorage.clear();
        return <Unauth />;
      }
    };
  };
}

export default withAuth;
